<app-header></app-header>

<div class="container mt-4 h-100 overflow-auto">
    <div class="container plns">
        <h2>Scholarships</h2>    
    </div>
    <div class="home_content">
      <!-- <div class="ms-3">
        
        <p class="good_1">It’s a great day to apply for a new scholarship</p>
        <p class="heading_ mt-3 mb-0">FEATURED SCHOLARSHIPS</p>
      </div> -->
  
        <div class="card_outer">
            <div class="row">
                    <div class="card col-5 mt-3 ms-4 me-4 p-0" [style.max-height]="'450px'" *ngFor="let data of scholarshipsList">
                        <img  [src]="data.image ? data.image : '../../../assets/images/dummy_img.svg'" class="card-img-top cover_" alt="...">
                        <div class="card-body">
                            <span class="d-inline-block">
                                <h5 class="card-title">{{data.title}}</h5>
                                <p class="deadline_">Deadline:<span class="ms-1">{{data.closingDate * 1000 | date}}</span></p>
                            </span>
                            <span class="d-inline-block float-end">
                                <!-- <p>s</p> -->
                            </span>
                         
                          <p [style.min-height]="'100px'" class="card-text">{{data.description?.length > 200 ? data.description.substring(0, 195) + "..." : data.description || "--"}}</p>
                          <div class="text-center">
                            <button class="btn know_">Know more</button>
                            <!-- <button class="btn apply_ ms-3">Apply now</button> -->
                          </div>
                          
                        </div>
                      </div>
            </div>
        </div>
    </div>
</div>
<app-spinner *ngIf="isLoading == true"></app-spinner>